import React from 'react';

import {JourneyActionBar} from './shared/components';

interface ActionConfig {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}

interface ApplicationJourneyStepLayoutProps {
  title: string;
  description?: string;
  primaryAction?: ActionConfig;
  secondaryAction?: ActionConfig;
  showFooterActions?: boolean;
  children: React.ReactNode;
}

function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

const ApplicationJourneyStepLayout: React.FC<
  ApplicationJourneyStepLayoutProps
> = ({
  title,
  description,
  primaryAction,
  secondaryAction,
  showFooterActions = true,
  children,
}) => {
  const hasActions = Boolean(primaryAction || secondaryAction);

  const renderActions = (wrapperClassName?: string) => {
    if (!hasActions) return null;

    return (
      <JourneyActionBar
        className={cx('application-stage__actions', wrapperClassName)}
        secondaryAction={secondaryAction}
        primaryAction={primaryAction}
      />
    );
  };

  return (
    <div className="application-step">
      <div className="application-stage__header">
        <div className="application-stage__title">
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
      </div>
      <div className="application-stage__content">{children}</div>
      {showFooterActions
        ? renderActions('application-stage__actions--footer')
        : null}
    </div>
  );
};

export default ApplicationJourneyStepLayout;
